import { styled } from "@mui/material/styles";

export const SideBar = styled("rect")(({ theme }) => ({
  fill: theme.vars.palette.background.paper,
}));
